export default __webpack_public_path__ + "static/media/Deo-Night.51780c4f.jpg";